class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp.bind(this));

    // Safari does not move focus to a link on click, so document.activeElement
    // falls back to <body> and onFocusOut would close this disclosure
    // synchronously during the click — which cancels the link navigation.
    // Flag a pointer press on a same-tab link so that one close is skipped.
    this.mainDetailsToggle.addEventListener('pointerdown', this.onPointerDown.bind(this));

    // Desktop hover support for navigation menus
    if (this.closest('.header__inline-menu')) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    this.open();
  }

  onMouseLeave() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    this.close();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onPointerDown(event) {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const opensNewContext =
      link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey;
    this.skipNextFocusOut = !opensNewContext;
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.skipNextFocusOut) {
        this.skipNextFocusOut = false;
        return;
      }
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyUp(event) {
    if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.close();
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.focus();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}
